<template>
  <FlexCol gap-3 class="h-full min-h-0">
    <Title :title="paramScreenName" :breadcrumb="true">
      <SelectMultiple v-if="allHeaders" v-model="selectHeaders" :items="allHeaders" item-value="field" item-text="title" class="w-[240px]" disableClear />

      <DropDown v-if="false">
        <template #action>
          <Button light label="Relatórios" icon="fa-solid fa-file-invoice" />
        </template>
        <template #default>
          <FlexCol gap-3 class="w-[320px] mt-2">
          </FlexCol>
        </template>
      </DropDown>

      <Filter :filters="filterObject" v-model="filters" />

      <Button primary label="Voltar" icon="fa-solid fa-chevron-left" @click="router.back()" v-if="backButton" />


      <Button
        v-if="!disableRegister"
        id="addResourceBtn"
        :label="paramButtonNew"
        primary
        icon="fa-solid fa-circle-plus"
        @click="navigate(paramRouteAdd)"
        v-can="`${scope}.create`" />

      <div v-else class="flex shrink-0 flex-nowrap items-center gap-2 whitespace-nowrap">
        <slot name="customNavigation"></slot>
      </div>

      <slot name="title-buttons" v-bind="{ filters, items, route }"></slot>
    </Title>

    <slot name="middle-card"></slot>
    <Loader v-if="loader" />

    <div class="grow min-h-0 relative">
      <Flex gap-3 items-stretch class="h-full min-h-0">
        <div class="grow min-h-0 overflow-hidden">
          <TableFull :headers="computedHeaders" :items="items" v-model="tableControl" :table-fixed="Boolean(props.modelValue.tableFixed)" @selectedItem="handleSelectItem" @doubleClick="handleDoubleClick" dense>
            <template v-slot:actions="{ item }">
              <div class="flex items-center justify-center gap-1 whitespace-nowrap">
                <slot name="actions" v-bind="{ item }"></slot>
                <Tooltip label="Editar">
                  <IconButton v-if="!disableEdit" icon="fa-solid fa-pen" aria-label="Editar" @click="handleEdit(item)" v-can="`${scope}.edit`" />
                </Tooltip>
                <Tooltip label="Excluir" v-if="!disableDelete">
                  <IconButton icon="fa-solid fa-trash" v-if="props.canDelete(item)" aria-label="Excluir" @click.stop="removeConfirm(item, $event)" v-can="`${scope}.delete`" />
                </Tooltip>
              </div>
            </template>
            <template v-for="head in computedHeaders.filter((head) => head.field !== 'actions')" #[`${head.field}`]="{ item }">
              <slot :name="`${head.field}`" v-bind="{ item, head }">
                <TableCellValue :item="item" :header="head" />
              </slot>
            </template>
          </TableFull>
        </div>
        <div class="w-[640px] shrink-0" v-if="selected && selectable"></div>
      </Flex>
      <Card variant="cockpit" class="w-[640px] absolute top-0 right-0 bottom-2 overflow-y-scroll" v-if="selected && selectable">
        <FlexCol gap-3>
          <Flex items-center justify-between class="pb-3 border-b border-cockpit-line">
            <slot name="card-title" v-bind="{ item: selected }">
              <span>{{ paramTitleCard }}</span>
            </slot>
            <Flex items-center justify-end gap-3>
              <IconButton icon="fa-solid fa-pen" @click="handleEdit(selected)" />
              <IconButton icon="fa-solid fa-x" @click="selected = null" />
            </Flex>
          </Flex>
          <slot name="card" v-bind="{ item: selected }"></slot>
        </FlexCol>
      </Card>
    </div>

    <Modal :title="paramTitleModalDelete" v-model="dialogDelete" size="w-3/12" disableClose>
      <template v-slot:default>
        {{ paramAskDelete }} <b>{{ choosed.name }}</b> ?
      </template>
      <template v-slot:footer>
        <Button id="serviceGroupRemoveBtn" primary label="Remover" @click="removeAcept()" />
        <Button danger label="Cancelar" @click="dialogDelete = false" />
      </template>
    </Modal>
  </FlexCol>
</template>

<!-- 
=============== Slots
Slots para Tabela : Nome do "Field" no header
Slot para Ação : actions

-->
<script setup>
import { ref, computed, onMounted, watch, onBeforeMount } from 'vue'
import { get, remove } from '@/crud.js'
import { useRouter, useRoute } from 'vue-router'
import TableCellValue from '@/components/lvm/molecules/TableCellValue.vue'

const router = useRouter()
const routeInfo = useRoute()

// Daqui pra cima é Genérico
const props = defineProps({
  modelValue: Object,
  selectable: Boolean,
  disableDelete: Boolean,
  disableEdit: { type: Boolean, default: false },
  refresh: Boolean,
  backButton: Boolean,
  disableRegister: { type: Boolean, default: false },
  disableExport: { type: Boolean, default: false },
  protocolRedirect: { type: Boolean, default: false },
  canDelete: { type: Function, default: () => true },
})

const emits = defineEmits('update:modelValue', 'update:refresh', 'removedItem')

const scope = ref(props.modelValue.scope ?? null)

const paramScreenName = computed(() => props.modelValue.screenName ?? '')
const paramButtonNew = ref(props.modelValue.buttonNew ?? '')
const paramAskDelete = ref(props.modelValue.askDelete ?? '')
const paramTitleModalDelete = ref(props.modelValue.titleModalDelete ?? '')
const paramTitleCard = ref(props.modelValue.titleCard ?? '')

const route = ref(props.modelValue.api ?? '')
const paramRouteAdd = ref(props.modelValue.routeAdd ?? '')
const paramRouteEdit = ref(props.modelValue.routeEdit ?? '')

const reports = ref(props.modelValue.reports)

const filterObject = ref(props.modelValue.filters)
const filters = ref(props.modelValue.filter ?? [])

const filterPerene = ref(props.modelValue.filterPerene)

const headers = ref(props.modelValue.headers)
const allHeaders = ref(props.modelValue.allHeaders)
const selectHeaders = ref([...headers.value.map((el) => el.field)])
const headersLocal = ref([])
headersLocal.value = [
  ...props.modelValue.headers,
  {
    title: 'Ações',
    field: 'actions',
    itemClass: 'text-center whitespace-nowrap',
    headerClass: 'justify-center',
    disableOrder: true,
  },
]

//  Controle de Tabela
const tableControl = ref({
  page: 1,
  total: 0,
  limit: 50,
  pages: 0,
  order: props.modelValue.order || [],
})

const choosed = ref(null)
const selected = ref(null)
const items = ref([])
const loader = ref(false)
const dialogDelete = ref(false)

const isLoading = ref(false)
const initializing = ref(true)
// Computados
const computedHeaders = computed(() => {
  if (!allHeaders.value) {
    return headersLocal.value
  }
  const data = []
  const fixed = headers.value.filter((el) => el.fixed)
  const selectableHeaders = allHeaders.value.filter((el) => selectHeaders.value.includes(el.field))
  data.push(...fixed)
  data.push(...selectableHeaders)
  data.push({
    title: 'Ações',
    field: 'actions',
    itemClass: 'text-center whitespace-nowrap',
    headerClass: 'justify-center',
    disableOrder: true,
  })
  return data
})

const combinedFilters = computed(() => {
  const combined = [...(filters.value || [])]
  if (filterPerene.value && filterPerene.value.length > 0) {
    combined.push(...filterPerene.value)
  }
  return combined
})

const STORAGE_KEY = 'manage-shell-control'

const clearStorage = () => {
  const allStates = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}')
  allStates[routeInfo.name] = null
  localStorage.setItem(STORAGE_KEY, JSON.stringify(allStates))
  filters.value = null
  loadItems(5)
}

const saveState = () => {
  if (!routeInfo.name) return

  try {
    const allStates = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}')
    allStates[routeInfo.name] = {
      filters: filters.value,
      tableControl: {
        page: tableControl.value.page,
        limit: tableControl.value.limit,
        order: tableControl.value.order,
      },
      selectHeaders: selectHeaders.value,
    }
    localStorage.setItem(STORAGE_KEY, JSON.stringify(allStates))
  } catch (error) {
    console.error('Erro ao salvar estado no localStorage:', error)
  }
}

const uniqueByKey = (array, key) => {
  const seen = new Set()
  return array.filter((item) => {
    if (seen.has(item[key])) return false
    seen.add(item[key])
    return true
  })
}

const loadState = () => {
  if (!routeInfo.name) return false

  try {
    const allStates = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}')
    const state = allStates[routeInfo.name]

    if (!state) return false
    if (state.filters) {
      if (!filters.value || filters.value.length === 0) {
        filters.value = state.filters
      } else {
        filters.value.push(...state.filters)
        filters.value = uniqueByKey(filters.value, 'column')
      }
    }

    if (state.tableControl) {
      if (state.tableControl.page) tableControl.value.page = state.tableControl.page
      if (state.tableControl.limit) tableControl.value.limit = state.tableControl.limit
      if (state.tableControl.order) tableControl.value.order = state.tableControl.order
    }
    if (state.selectHeaders && allHeaders.value) {
      selectHeaders.value = state.selectHeaders
    }

    return true
  } catch (error) {
    console.error(error)
    return false
  }
}

// Metódos
const navigate = (routeName, paramObj) => {
  let route = {
    name: routeName,
    params: { ...(routeInfo.params || {}) },
  }
  if (paramObj) {
    route.params = { ...route.params, ...paramObj }
  }

  router.push(route)
}

const loadItems = async (f = 0) => {
  if (isLoading.value) return // evita duplicar
  isLoading.value = true

  try {
    loader.value = true

    const query = {
      params: {
        page: tableControl.value.page,
        limit: tableControl.value.limit,
        order: tableControl.value.order,
        filters: [],
      },
    }

    if (filters.value?.length) query.params.filters.push(...filters.value)
    if (filterPerene.value?.length) query.params.filters.push(...filterPerene.value)

    const raw = await get(route.value, query)

    items.value = raw.data
    tableControl.value.pages = Math.ceil(raw.total / tableControl.value.limit)
    tableControl.value.total = raw.total
  } catch (error) {
    console.error(error.message)
  } finally {
    loader.value = false
    isLoading.value = false
  }
}

const removeConfirm = (item, event) => {
  if (event) {
    event.preventDefault()
    event.stopPropagation()
  }
  if (!props.canDelete(item)) return
  choosed.value = item
  dialogDelete.value = true
}

const removeAcept = async () => {
  dialogDelete.value = false
  selected.value = null
  await remove(route.value, choosed.value.id, 'recurso')
  await loadItems(1)
  emits('removedItem')
}

// Funções de Ação
const handleSelectItem = (item) => {
  selected.value = item
}

const handleEdit = (item) => {
  if (props.protocolRedirect) {
    return navigate(paramRouteEdit.value, { protocolo: item.protocolo }, true)
  }
  navigate(paramRouteEdit.value, { id: item.id }, true)
}

const handleDoubleClick = (item) => {
  if (props.protocolRedirect) {
    const resolved = router.resolve({
      name: paramRouteEdit.value,
      params: { protocolo: item.protocolo },
    })
    window.open(resolved.href, '_blank')
    return
  }
  handleEdit(item)
}

// Watchers

watch(
  () => tableControl.value,
  async () => {
    if (initializing.value) return
    await loadItems(3)
    saveState()
  },
  { deep: true },
)

watch(
  () => props.refresh,
  async (newVal) => {
    if (!newVal) return
    if (initializing.value) return
    await loadItems(4)
    emits('update:refresh', false)
  },
)

watch(
  () => selectHeaders.value,
  () => {
    saveState()
  },
  { deep: true },
)

watch(
  filters,
  async () => {
    if (initializing.value) return
    tableControl.value.page = 1
    saveState()
    await loadItems(2)
  },
  { deep: true },
)

onBeforeMount(() => {
  loadState()
})

onMounted(async () => {
  await loadItems()
  initializing.value = false
})
</script>
